import { getStage, Stage } from '@amzn/aws-howser-client-config';

export const isNullish = (value: unknown): value is null | undefined => {
  return value === null || typeof value === 'undefined' || value === '';
};

interface AdobeAnalysticsOptions {
  type?: string;
  name?: string;
  description?: string;
}
/**
 * @description Sending data to admobe anlytics on event
 * @param values
 */
export const sendToAdobeAnalyticsOnClick = (values: AdobeAnalysticsOptions) => {
  try {
    const opt = {
      event: {
        type: values.type,
        name: values.name,
        description: values.description,
      },
      data: {
        url: window.location.href,
      },
    };
    if (!!window.AWSMA && !!window.AWSMA.ready && !!window.AWSMA.TRIGGER_EVENT) {
      window.AWSMA.ready(function () {
        // Trigger a pageview call
        document.dispatchEvent(new CustomEvent(window.AWSMA.TRIGGER_EVENT, { detail: opt }));
      });
    }
  } catch (error) {
    // console.log(error);
    throw error;
  }
};

export const getAppStage = (): Stage => {
  return getStage();
};
